import { NgModule, InjectionToken } from '@angular/core';
import { TransactionRepository } from '../../domain/transaction/transaction-repository';
import { TransactionHttpRepository } from './transaction-http.repository';
import { QuoteRepository } from '../../domain/quote/quote-repository';
import { QuoteHttpRepository } from './quote-http.repository';
import { RecipientRepository } from '../../domain/recipient/recipient-repository';
import { RecipientHttpRepository } from './recipient-http.repository';

export const QUOTE_REPOSITORY = new InjectionToken<QuoteRepository>('QuoteRepository');
export const RECIPIENT_REPOSITORY = new InjectionToken<RecipientRepository>('RecipientRepository');

@NgModule({
  providers: [
    {
      provide: TransactionRepository,
      useClass: TransactionHttpRepository
    },
    {
      provide: QUOTE_REPOSITORY,
      useClass: QuoteHttpRepository
    },
    {
      provide: RECIPIENT_REPOSITORY,
      useClass: RecipientHttpRepository
    }
  ]
})
export class RepositoryModule { }
